module.exports = __webpack_public_path__ + "static/media/como-46.004c2020.jpg";